import api from './api';

export interface GADMZone {
  id: string;
  name: string;
  // Use a broad type here to avoid requiring external geojson typings
  geometry: any;
}

export const gadmService = {
  searchZones: async (query: string): Promise<GADMZone[]> => {
    try {
      const response = await api.get(`/gadm/search?query=${query}`);
      return response.data;
    } catch (error) {
      console.error('Error searching GADM zones:', error);
      throw error;
    }
  },
};
